// extracted by mini-css-extract-plugin
export var actionIcon = "_tx-0";